import { useOrgEntitlements } from "@/hooks/useOrgEntitlements";
import { usePermissions } from "@/hooks/usePermissions";

/**
 * The signed-in caller's own organization's entitlements — the common case.
 *
 * Named for whose plan it resolves so the wrong choice reads wrong. A GFG surface acting on a
 * client's organization must use `useOrgEntitlements(org.id)`: this one would silently answer with
 * GFG's own plan, which is unlimited, and every gate would open.
 */
export function useMyEntitlements() {
  const { organizationId } = usePermissions();
  return useOrgEntitlements(organizationId);
}
